import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "site_index_footer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"230px","height":"30px","margin-top":"13px","margin-left":"40%"} }, [
  /*#__PURE__*/_createTextVNode("备案号："),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://beian.miit.gov.cn/",
    target: "_blank"
  }, "粤ICP备18056100号-1")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, _hoisted_3))
}